<div class="dialog-header">
  <h2 mat-dialog-title class="dialog-title">Set a country term rule</h2>
  <p class="dialog-subtitle">Decide what a country calls a term, whether it's required, and whether it's published.</p>
</div>

<mat-dialog-content class="dialog-content">
  <app-error-banner [message]="errorMessage()" />

  <mat-form-field appearance="outline">
    <mat-label>Country</mat-label>
    <mat-select [(ngModel)]="countryCode" name="countryCode">
      @for (c of countries(); track c) {
        <mat-option [value]="c">{{ countryLabel(c) }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Field</mat-label>
    <mat-select [(ngModel)]="term" name="term">
      @for (t of terms(); track t) {
        <mat-option [value]="t">{{ t }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Event type (optional)</mat-label>
    <input matInput [(ngModel)]="eventType" name="eventType" placeholder="AggregationEvent" />
    <mat-hint>Omit for a rule that applies to every event type</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Local name (optional)</mat-label>
    <input matInput [(ngModel)]="localName" name="localName" placeholder="Z7439g33" />
    <mat-hint>What this country calls the field on chain. Omit to keep the canonical name.</mat-hint>
  </mat-form-field>

  <div class="checkbox-row">
    <mat-checkbox [(ngModel)]="required" name="required">Required</mat-checkbox>
    <p class="checkbox-hint">Required fields are also written to chain.</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
  <button mat-flat-button class="btn-submit" (click)="submit()" [disabled]="isSubmitting() || !canSubmit">
    @if (isSubmitting()) {
      <mat-icon class="spinner">progress_activity</mat-icon>
    }
    {{ isSubmitting() ? 'Saving…' : 'Save' }}
  </button>
</mat-dialog-actions>
